import { unitLengths as e, oldOdiTaxonomyLengths as m } from "./unitLengths.mjs";
const s = e, x = m, n = {
  px: "1px",
  // NO MATCH - size.s1 (defined in rem)
  max: "max-content",
  // NO MATCH - special case
  min: "min-content",
  // NO MATCH - special case
  full: "100%",
  // NO MATCH - special case
  prose: "60ch"
}, o = {
  "3xs": "14rem",
  // NO MATCH - size.s224
  "2xs": "16rem",
  // NO MATCH - size.s256
  xs: "20rem",
  // NO MATCH - size.s320
  sm: "24rem",
  // NO MATCH - size.s384
  md: "28rem",
  // NO MATCH - size.s448
  lg: "32rem",
  // NO MATCH - size.s512
  xl: "36rem",
  // NO MATCH - size.s576
  "2xl": "42rem",
  // NO MATCH - size.s672
  "3xl": "48rem",
  // NO MATCH - size.s768
  "4xl": "56rem",
  // NO MATCH - size.s896
  "5xl": "64rem",
  // NO MATCH - size.s1024
  "6xl": "72rem",
  // NO MATCH - size.s1152
  "7xl": "80rem",
  // NO MATCH - size.s1280
  "8xl": "90rem"
  // NO MATCH - size.s1440
}, r = {
  container: {
    sm: "640px",
    // NO MATCH - special case
    md: "768px",
    // NO MATCH - special case
    lg: "1024px",
    // NO MATCH - special case
    xl: "1280px"
    // NO MATCH - special case
  },
  icon: {
    sm: "1em",
    // NO MATCH - special case
    md: "1.5em",
    // NO MATCH - special case
    lg: "2em",
    // NO MATCH - special case
    xl: "2.25em"
    // NO MATCH - special case
  }
}, t = {
  ...s,
  ...n,
  ...o,
  ...x,
  ...r
}, l = t;
export {
  r as categorizedSubSizes,
  l as default,
  x as oldOdiSizes,
  o as sizedSizes,
  t as sizes,
  n as specialSizes,
  s as unitSizes
};
